import React from 'react';
import { ArrowRightIcon, CalendarIcon, ClockIcon, MonitorIcon } from 'lucide-react';
import { useWebinar } from '../../hooks/useWebinar';
import { trackEvent } from '../../utils/analytics';
import { Flag } from './Flag';

/** Prominent session card in the hero: the active-language session, plus the other session as an alternative. */
export function SessionCard() {
  const {
    copy,
    session,
    otherSession,
    switchSession
  } = useWebinar();
  const c = copy.hero;
  return <div className="mt-9 max-w-[38rem] rounded-[22px] border border-white/[0.12] bg-[#0B0F26] overflow-hidden shadow-[0_30px_70px_-40px_rgba(79,70,229,0.6)]" data-id="element-7845" data-mp="a008seemffs3">
      <div className="p-6 md:p-7" data-id="element-7846" data-mp="2vpqng2o0fi">
        <p className="flex items-center gap-2.5 font-sans text-[11.5px] font-semibold tracking-[0.18em] uppercase text-[#C7C4FF]" data-id="element-7847" data-mp="61ajqho4g5f">
          <Flag code={session.flag} data-id="element-7848" data-mp="2ktcupvrlsrr3" />
          {session.label}
        </p>

        <p className="mt-4 flex items-center gap-3 font-serif text-[1.75rem] md:text-[2rem] leading-tight text-white" data-id="element-7849" data-mp="2pszbgf6n4q4n">
          <CalendarIcon className="hidden sm:block w-6 h-6 shrink-0 text-[#A5A1FF]" aria-hidden="true" data-id="element-7850" data-mp="jxh7dfhhavv0" />
          {session.date}
        </p>
        <p className="mt-2 flex items-center gap-3 font-sans text-[1.15rem] md:text-[1.3rem] font-semibold text-[#C7C4FF]" data-id="element-7851" data-mp="fy03urlm48sh">
          <ClockIcon className="hidden sm:block w-6 h-6 shrink-0 text-[#A5A1FF]" aria-hidden="true" data-id="element-7852" data-mp="ttu12dd0x9pr" />
          {session.time}
        </p>
        <p className="mt-3 flex items-center gap-2 font-sans text-[13.5px] text-[#A6ABC8] sm:pl-9" data-id="element-7853" data-mp="12w37ar19egxc">
          <MonitorIcon className="w-3.5 h-3.5 text-[#8A90B2]" aria-hidden="true" data-id="element-7854" data-mp="yw2utbxq0fsx" />
          {c.duration} · {c.format}
        </p>

        <a href="#inscription" onClick={() => trackEvent('webinar_cta_click', {
        location: 'hero',
        session: session.id
      })} className="group mt-6 w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-[#4F46E5] px-7 py-4 font-sans text-[15px] font-semibold text-white shadow-[0_14px_40px_-12px_rgba(79,70,229,0.8)] hover:bg-[#5B52F0] transition-colors duration-150" data-id="element-7855" data-mp="1cm68heijb16r">
          {session.cta}
          <ArrowRightIcon className="w-4 h-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-7856" data-mp="1tniucpb5evm3" />
        </a>
      </div>

      {/* Alternative session */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 border-t border-white/[0.08] bg-white/[0.02] px-6 md:px-7 py-4" data-id="element-7857" data-mp="23dvfojqsesta">
        <div className="font-sans text-[13.5px] leading-snug" data-id="element-7858" data-mp="28cezadhwrsih">
          <p className="text-[#A6ABC8]" data-id="element-7859" data-mp="2cds7gu8h47sk">{c.altQuestion}</p>
          <p className="mt-0.5 flex items-center gap-2 font-semibold text-white" data-id="element-7860" data-mp="2cgee8rnjij9q">
            <Flag code={otherSession.flag} className="w-4 h-[11px]" data-id="element-7861" data-mp="2hefuz5xhu6i1" />
            {otherSession.altLine}
          </p>
        </div>
        <button type="button" onClick={() => {
        trackEvent('webinar_switch_session', {
          to: otherSession.id
        });
        switchSession();
      }} className="group self-start sm:self-auto inline-flex items-center gap-1.5 font-sans text-[13.5px] font-semibold text-[#C7C4FF] hover:text-white transition-colors duration-150 whitespace-nowrap" data-id="element-7862" data-mp="mzlqjneq101e">
          {c.altLink}
          <ArrowRightIcon className="w-3.5 h-3.5 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-7863" data-mp="aouqbyxwoh53" />
        </button>
      </div>
    </div>;
}